import * as api from "./dEdmProductsAPI";
import * as ac from "./dEdmProductsActionCreators";
import { call, put, takeLatest } from "redux-saga/effects";
import { dashboardLoaderAC } from "../system/systemActionCreators";
import { errorGenerator, notificationCreator } from "model/system/utils";
import { typeAddEdmProductsItemObject } from "../../components/containers/dashboard/dataEdmProducts/popupContents/popupAdd";
import { typeEditEdmProductsItemObject } from "../../components/containers/dashboard/dataEdmProducts/popupContents/popupEdit";
import {
  Root,
  typeProductsFilters,
  IdProductsStateDataItem,
} from "./dEdmProductsReducer";
import {
  typePagination,
  paginationMapper,
  typeRequestPagination,
} from "../system/constants";

/**
 * Temp data list mapper
 */
const tempDataMapper = (data: Root["content"]): IdProductsStateDataItem[] =>
  data.map(({ product, ...rest }) => ({
    ...rest,
    ...product,
  }));

/**
 * Get data function-generator
 */
function* getData(payload: {
  primaryTenant: string;
  filters: typeProductsFilters;
  paginationRequest: typeRequestPagination;
}) {
  let response = yield call(api.getEdmProductList, payload);

  if (response.status === 200) {
    const tempData: IdProductsStateDataItem[] = tempDataMapper(
      response.data.content,
    );
    const pagination: typePagination = paginationMapper(response.data);

    yield put(ac.dEdmProductsSetPaginationAC(pagination));

    yield put(ac.dEdmProductsSetDataAC(tempData));
  } else {
    yield errorGenerator(response);
  }
}

/**
 * Set product list saga worker
 */
export function* dEdmProductsSetDataWorker(actionObject: {
  type: string;
  payload: {
    primaryTenant: string;
    filters: typeProductsFilters;
    paginationRequest: typeRequestPagination;
  };
}) {
  yield put(dashboardLoaderAC(true));

  yield getData(actionObject.payload);

  yield put(dashboardLoaderAC(false));
}

export function* dEdmProductsSetDataWatcher() {
  yield takeLatest(
    ac.dEdmProductsSetDataSagaAC.type,
    dEdmProductsSetDataWorker,
  );
}

export function* dEdmProductsAddItemWorker(actionObject: {
  type: string;
  payload: {
    itemObject: typeAddEdmProductsItemObject;
    requestData?: {
      primaryTenant: string;
      filters: typeProductsFilters;
      paginationRequest: typeRequestPagination;
    };
  };
}) {
  if (actionObject.payload.requestData) {
    yield put(dashboardLoaderAC(true));
  }

  let response = yield call(
    api.addEdmProductItem,
    actionObject.payload.itemObject,
  );

  if (response.status === 200) {
    yield notificationCreator("SUCCESS_ADD_ITEM");

    if (actionObject.payload.requestData) {
      yield getData(actionObject.payload.requestData);
    }
  } else {
    yield errorGenerator(response);
  }

  if (actionObject.payload.requestData) {
    yield put(dashboardLoaderAC(false));
  }
}

export function* dEdmProductsAddItemWatcher() {
  yield takeLatest(
    ac.dEdmProductsAddItemSagaAC.type,
    dEdmProductsAddItemWorker,
  );
}

export function* dEdmProductsEditItemWorker(actionObject: {
  type: string;
  payload: {
    itemObject: typeEditEdmProductsItemObject;
    requestData?: {
      primaryTenant: string;
      filters: typeProductsFilters;
      paginationRequest: typeRequestPagination;
    };
  };
}) {
  if (actionObject.payload.requestData) {
    yield put(dashboardLoaderAC(true));
  }

  let response = yield call(
    api.editEdmProductItem,
    actionObject.payload.itemObject,
  );

  if (response.status === 200) {
    yield notificationCreator("SUCCESS_CHANGE_ITEM");

    if (actionObject.payload.requestData) {
      yield getData(actionObject.payload.requestData);
    }
  } else {
    yield errorGenerator(response);
  }

  if (actionObject.payload.requestData) {
    yield put(dashboardLoaderAC(false));
  }
}

export function* dEdmProductsEditItemWatcher() {
  yield takeLatest(
    ac.dEdmProductsEditItemSagaAC.type,
    dEdmProductsEditItemWorker,
  );
}
